// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_mq-0";